export default __webpack_public_path__ + "static/media/Loading.a1a99674.gif";